import MuiCheckbox, { CheckboxProps } from '@mui/material/Checkbox';

import { InputBaseProps } from '@mui/material/InputBase';
import React from 'react';

export type CustomCheckboxProps = CheckboxProps &
  InputBaseProps & {
    coloredOutline?: boolean; // Apply same color to the outline
  };

const Checkbox: React.FC<CustomCheckboxProps> = ({ color = 'primary', coloredOutline = true, ...rest }) => (
  <MuiCheckbox sx={coloredOutline ? { color: `${color}.dark`, '&.Mui-checked': { color: `${color}.main` } } : {}} {...rest} />
);

export default Checkbox;
